import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
    lang: "en",
    setLang: () => {},
    t: (k) => k,
});

const STORAGE_KEY = "wynwood_lang";

function detectInitialLang() {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "es" || stored === "it" || stored === "fr") return stored;
    const browser = (navigator.language || "en").toLowerCase();
    if (browser.startsWith("es")) return "es";
    if (browser.startsWith("it")) return "it";
    if (browser.startsWith("fr")) return "fr";
    return "en";
}

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(detectInitialLang);

    useEffect(() => {
        try {
            window.localStorage.setItem(STORAGE_KEY, lang);
            document.documentElement.setAttribute("lang", lang);
        } catch (_) {
            /* noop */
        }
    }, [lang]);

    const setLang = useCallback((next) => {
        if (["en", "es", "it", "fr"].includes(next)) setLangState(next);
    }, []);

    const t = useCallback(
        (key) => {
            const dict = translations[lang] || translations.en;
            return dict[key] ?? translations.en[key] ?? key;
        },
        [lang],
    );

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useT() {
    return useContext(LanguageContext);
}
